export function paymentDetailsReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "GET_PAYMENT_DETAILS":

            return payload            
    
        default:
            return state;
    }
    
}